<script>
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'
import UserAvatar from '@components/user/user-avatar.vue'

export default {
  name: 'NavDrawerProfileActionsContainer',
  components: {
    UserAvatar,
  },
  mixins: [baseMixin],
  props: {
    mobileView: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
      user: 'auth/currentUser',
      userFullName: 'auth/currentUserFullName',
      userEmail: 'auth/currentUserEmail',
      isLoggedIn: 'auth/isUserLoggedIn',
      isLoadingAuth: 'auth/isLoadingAuth',
      isMini() {
        return !this.isMobileViewPort && this.mini
      },
    }),
    compFullName() {
      return (
        this.userFullName || this.$t('layout.profileDropdownDefaultUserName')
      )
    },
  },
  methods: {
    ...mapActions({
      toggleMiniDrawer: 'toggleDrawer',
      logOut: 'auth/logOut',
    }),
    signOut() {
      this.logOut({ redirect: true, nuke: true })
    },
  },
}
</script>

<template>
  <div
    :class="[
      mobileView ? 'px-4 pb-2 d-flex' : 'd-flex',
      !mobileView && mini
        ? 'flex-column flex-wrap align-center justify-center nav-btn'
        : '',
    ]"
    style="padding-bottom: 12px"
  >
    <!-- Desktop Profile button -->
    <v-tooltip v-if="!mobileView" :disabled="!mini" right>
      <template v-slot:activator="{ on }">
        <BaseButton
          :class="[
            'pa-4 d-flex align-center nav-btn',
            mini && 'nav-btn-mini',
            !mini && 'justify-start',
          ]"
          :style="mini ? 'padding:6px!important;' : ''"
          color="white"
          hover-color="transparent"
          :width="'80%'"
          :height="'48'"
          v-on="on"
        >
          <UserAvatar
            size="sm"
            :name="userFullName"
            :badge="isImpersonating"
            badge-color="blue"
            badge-dot
            badge-offset-x="10"
            badge-offset-y="10"
          />
          <span v-if="!mini" class="ms-2">{{ compFullName }}</span>
        </BaseButton>
      </template>
      <span>Profile</span>
    </v-tooltip>

    <!-- Mobile profile button -->
    <BaseButton
      v-else
      class="pa-7 px-4 d-flex align-center justify-start"
      :style="mini ? 'padding:6px!important;' : ''"
      color="white"
      hover-color="transparent"
      :width="'80%'"
    >
      <UserAvatar
        size="sm"
        :name="userFullName"
        :badge="isImpersonating"
        badge-color="blue"
        badge-dot
        badge-offset-x="10"
        badge-offset-y="10"
        :style="{ marginRight: '8px' }"
      />
      <span class="ms-2 profile-user" style="font-weight: 500">{{
        compFullName
      }}</span>
    </BaseButton>

    <!-- Sign-out button -->
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <BaseButton
          :class="[
            mobileView ? 'pa-7' : 'pa-4 hover-bg-color sign-out-btn',
            !mobileView && !mini && 'align-self-center',
          ]"
          :width="mobileView ? '20%' : '28'"
          :height="mobileView ? '48' : '28'"
          color="white"
          hover-color="blue400"
          :border-radius="'8px'"
          data-cy="sign-out-btn"
          @click="signOut"
          v-on="on"
        >
          <v-icon
            :size="mobileView ? 20 : undefined"
            :style="mobileView ? { marginRight: !mini ? '20px' : '' } : {}"
          >
            mdi-logout
          </v-icon>
        </BaseButton>
      </template>
      <span v-text="$t('layout.logout')"></span>
    </v-tooltip>
  </div>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';

.profile-user {
  color: $color-gray-600 !important;
}
</style>
